import { createSlice } from '@reduxjs/toolkit';

export interface PaymentState {
  failureCount: number;
}

const initialState: PaymentState = {
  failureCount: 0,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    incrementFailureCount: (state) => {
      state.failureCount++;
    },
    resetFailureCount: (state) => {
      state.failureCount = 0;
    },
  },
});

export const { incrementFailureCount, resetFailureCount } = paymentSlice.actions;
export default paymentSlice.reducer;
